function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function cloneInvoiceForForm(factura, fecha = todayISO()) {
  const clone = { ...(factura || {}) };
  delete clone._id;
  delete clone.id;
  delete clone.userId;
  delete clone.companyId;
  delete clone.createdAt;
  delete clone.updatedAt;
  delete clone.gestiones;
  delete clone.pagos;
  delete clone.adjunto;
  delete clone.metadata;
  delete clone.numero;
  delete clone.montoPagado;
  clone.fecha = fecha;
  clone.vencimiento = '';
  clone.estadoPago = 'impaga';
  clone.recurrente = false;
  clone.proximaFecha = '';
  clone.saldo = clone.total;
  return clone;
}

export function cloneExpenseForForm(gasto, fecha = todayISO()) {
  return {
    fecha,
    concepto: gasto?.concepto || '',
    monto: gasto?.monto ?? 0,
    moneda: gasto?.moneda || 'ARS',
    tipoCambio: gasto?.tipoCambio ?? '',
    categoria: gasto?.categoria || '',
    proveedor: gasto?.proveedor || '',
    cliente: gasto?.cliente || '',
    notas: gasto?.notas || '',
    alicuotaIva: gasto?.alicuotaIva || 0,
    pagado: gasto?.pagado !== false,
    recurrente: false,
    proximaFecha: '',
  };
}
